<template>
    <v-layout justify-center>
        <v-responsive max-width="1280px" width="100%">
            <list-heading v-model="showsSearch" :title="`${title} 목록`" />
            <v-data-table :items="items" :headers="headers" hide-default-footer disable-sort class="my-4 v-sheet--outlined">
                <template #[`item.duration`]="{ item }">
                    <program-list-duration :value="item" />
                </template>

                <template #[`item.applications`]="{ item }">
                    <application-list :program="item" />
                </template>

                <template #[`item.actions`]="{ item }">
                    <v-row>
                        <program-view v-model="programs" :item="item" /> <v-btn @click="remove(item)" small text> <v-icon small>mdi-delete</v-icon> </v-btn>
                    </v-row>
                </template>
            </v-data-table>

            <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="my-4" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>

            <program-view v-model="programs" :title="title" :category="category" isNew @input="totalCount += 1" />
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import ListHeading from "@/components/console/dumb/list-heading.vue";
import ProgramView from "@/components/console/services/program-view.vue";
import ProgramListDuration from "@/components/console/services/program-list-duration.vue";
import ApplicationList from "@/components/console/services/application-list.vue";

const TITLES = {
    education: "서비스-교육",
    unit: "서비스-단위지원",
    total: "서비스-토탈지원",
};

const headers = [
    { text: "번호", value: "index", width: 60, align: "center" },
    { text: "내용", value: "title" },
    { text: "신청기간", value: "duration", width: 200, align: "center" },
    { text: "상태", value: "status", width: 100, align: "center" },
    { text: "신청서", value: "applications", width: 100, align: "center" },
    { text: "", value: "actions", width: 120 },
];

export default {
    components: {
        ListHeading,
        ProgramListDuration,
        ProgramView,
        ApplicationList,
    },
    computed: {
        category() {
            return this.$route.params?.category?.toUpperCase?.();
        },
        title() {
            return TITLES[this.$route.params?.category];
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.totalCount / this.limit);
        },
        baseIndex() {
            return this.totalCount - this.skip;
        },
        items() {
            return this.programs.map((program, index) => ({ ...program, index: this.baseIndex - index }));
        },
    },
    data() {
        return {
            ///////////////////////////////////////////////
            // 검색필터
            ///////////////////////////////////////////////
            showsSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
            },

            page: +this.$route.query.page || 1,
            totalCount: 0,
            limit: 10,

            programs: [],
            headers,
        };
    },
    mounted() {
        this.init();
    },
    watch: {
        $route() {
            this.programs = [];
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            try {
                let { category } = this;

                var {
                    summary: { totalCount },
                    programs,
                } = await api.console.services.gets({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: { ...this.filter, category },
                });

                this.totalCount = totalCount;
                this.programs = programs;
            } catch (error) {
                this.$handleError(error);
            }
        },
        async remove({ _id }) {
            try {
                const go = confirm("해당 서비스를 삭제하시겠습니까?");
                if (go) {
                    await api.console.services.delete({ _id });
                    this.programs = this.programs.filter((program) => program._id !== _id);
                    this.totalCount -= 1;
                }
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
};
</script>
